<template>
    <company-select-modal titleKey="admin.user.action.updateCompany" :confirm-company="confirm" />
</template>

<script>

import { userRepository } from '@/repository/identity'
import CompanySelectModal from '@/components/admin/CompanySelectModal'

import { User } from '@/model/identity'

export default {
  components: { CompanySelectModal },
  props: {
    user: User
  },
  methods: {
    confirm (company) {
      const action = {
        action: 'update-company',
        company_id: company.id
      }
      return this.$store.dispatch(userRepository.execute, { entity: this.user, action: action })
    }
  }
}
</script>
